// Client lib imports
const businessEvents = require('client/lib/business-events')
const globalPageContext = require('client/lib/business-events/page-context')
// Client V2 common imports
const { render } = require('client-v2/common/client')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
// Entry imports
const configureStore = require('client-v2/logged-out-landing/state/store')
const rootFactory = require('client-v2/logged-out-landing/components/root').factory
const suSubmitModalActions = require('client-v2/logged-out-landing/containers/su-submit-modal/actions')

const { store } = render(configureStore, rootFactory)

globalPageContext.setPageContext({
  pageName: 'stream.profile'
})

businessEvents.trackInternal('pageview')
businessEvents.trackSegment('pageview')

store.dispatch(authModalActions.sanitizeQueryParams())
store.dispatch(suSubmitModalActions.maybeOpen())
